/**
 * 青蛙王子专用存储模块
 * */

const state = {
  qwwzConfig: {}, // 青蛙王子Apollo配置数据
  sizeList: [], // 选择通道后的出图尺寸列表
  channelList: [], // 选择的出图通道列表
  allPlatformSize: new Map(), // 所有平台的出图尺寸列表
  customModels: [], // 选择的垂直和私有模型列表
}

const mutations = {
  SET_QWWZ_CONFIG(state, config) {
    state.qwwzConfig = config;
  },
  SET_SIZE_LIST(state, sizeList) {
    state.sizeList = sizeList;
  },
  SET_CHANNEL_LIST(state, channelList) {
    state.channelList = channelList;
  },
  SET_ALL_PLATFORM_SIZE(state, platformSizeMap) {
    state.allPlatformSize = platformSizeMap;
  },
  SET_CUSTOM_MODELS(state, customModels) {
    state.customModels = customModels;
  }
}
const actions = {

}

const getters = {
  // 获取单个apollo配置
  getQwwzConfig: (state) => state.qwwzConfig,
  // 获取通道选择后的出图尺寸列表
  getSizeList: (state) => state.sizeList,
  // 获取选择的出图通道列表
  getChannelList: (state) => state.channelList,
  // 获取所有平台的出图尺寸列表
  getAllPlatformSize: (state) => state.allPlatformSize,
  // 获取选择的垂直和私有模型列表
  getCustomModels: (state) => state.customModels
}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}